<script setup lang="ts">
const props = defineProps<{
  curatedReferences: string[]
}>()

const curatedRef = useTemplateRef<HTMLElement>('curatedText')

useInternalLinkHandler(curatedRef, 'aside')

const sanitizedContent = computed(() => {
  return props.curatedReferences.join('')
})
</script>

<template>
  <div ref="curatedText" class="flex flex-col gap-m text-sm" v-html="sanitizedContent" />
</template>
